import { axios } from "@v2/shared/api";

export const postHelpForm = data => {
  return axios.post("appeals", data);
};
